import * as React from "react"
import type { SVGProps } from "react"
const SvgGift = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M17.83 7.43H20q.83 0 1.41.59.6.59.59 1.4v2q0 .84-.59 1.42a2 2 0 0 1-1.41.59v7q0 .83-.59 1.41a2 2 0 0 1-1.41.59H6q-.82 0-1.41-.59A2 2 0 0 1 4 20.43v-7q-.82 0-1.41-.59A2 2 0 0 1 2 11.43v-2q0-.82.59-1.41A2 2 0 0 1 4 7.42h2.17a3 3 0 1 1 5.83-1 3 3 0 1 1 5.83 1M8 6.43a1 1 0 0 0 1 1h1v-1a1 1 0 1 0-2 0m6 1h1a1 1 0 1 0-1-1zm-10 2v2h7v-2zm7 11v-7H6v7zm2 0h5v-7h-5zm7-9v-2h-7v2z"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgGift
